"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _UrlEmbed = _interopRequireDefault(require("./UrlEmbed.vue"));
var _default = exports.default = {
  components: {
    UrlEmbed: _UrlEmbed.default
  },
  props: ['url', 'component', 'componentProps', 'isIframe', 'showPin'],
  data() {
    return {
      debouncedUpdateEmbed: null
    };
  },
  computed: {
    iframeSandboxOptions() {
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox
      // Mostly all permissions other than allow-top-navigation so that embedded content
      // cannot redirect the page away from app
      let options = ['allow-downloads', 'allow-forms', 'allow-modals', 'allow-orientation-lock', 'allow-pointer-lock', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-presentation', 'allow-same-origin', 'allow-scripts'];
      return options.join(' ');
    }
  },
  watch: {
    url() {
      this.debouncedUpdateEmbed();
    },
    isIframe() {
      this.debouncedUpdateEmbed();
    }
  },
  created() {
    // Debounce as both watchers may call it in the same tick
    // also causes the method to be called next tick to give dom time to update
    this.debouncedUpdateEmbed = _lodash.default.debounce(() => {
      this.updateEmbed(true);
    }, 0);
  },
  mounted() {
    this.updateEmbed(false);
    this.$nextTick(() => {
      this.emitEvent('opened');
    });
  },
  methods: {
    updateEmbed(shouldEmit) {
      this.setMaxHeight('');
      if (this.isIframe || this.component) {
        this.setHeight(this.isIframe ? '40%' : 'auto');
      }
      if (shouldEmit) {
        this.emitEvent('updated');
      }
    },
    emitEvent(type) {
      const event = {
        isInline: this.showPin || false
      };
      if (this.isIframe) {
        event.type = 'iframe';
        event.iframe = this.$refs.iframe;
        event.url = this.url;
      } else if (this.component) {
        event.type = 'component';
        event.component = this.component;
        event.componentProps = this.componentProps;
      } else {
        event.type = 'embed';
        event.url = this.url;
      }
      this.$state.$emit(`mediaviewer.${type}`, event);
    },
    setHeight(newHeight) {
      this.$el.style.height = newHeight;
    },
    setMaxHeight(newHeight) {
      this.$el.style.maxHeight = newHeight;
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["MediaViewer"]
window._app_exports.components.MediaViewer = exports.default ? exports.default : exports;
